import type { DiscoveredRouteModule } from '@/router/generator/types';

const InternalServerErrorView = () => import('@/views/error-pages/InternalServerErrorView.vue');
export const NAME_INTERNAL_SERVER_ERROR = 'InternalServerError';
export const PATH_INTERNAL_SERVER_ERROR = '/internal-server-error';

export const route: DiscoveredRouteModule = {
  id: 'root.error.internal_server_error',
  scope: 'root',
  name: NAME_INTERNAL_SERVER_ERROR,
  path: PATH_INTERNAL_SERVER_ERROR,
  component: InternalServerErrorView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


